import { render, staticRenderFns } from "./dashBusinessWestudyUser.vue?vue&type=template&id=5be5915c&scoped=true&"
import script from "./dashBusinessWestudyUser.vue?vue&type=script&lang=js&"
export * from "./dashBusinessWestudyUser.vue?vue&type=script&lang=js&"
import style0 from "./dashBusinessWestudyUser.vue?vue&type=style&index=0&id=5be5915c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be5915c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
